define('contato-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('contato.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Contato', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, $multipart) {
      return {
          getImobiliariasContato: function(){
              return $q(function (resolve, reject) {
                  notify.clearNotifications();
                  $http.get(appRoute.linkTo('contato.getImobiliariasContato')).success(function (data) {
                      if (data && data.notifications && !_.isEmpty(data.notifications)) {
                          notify.addNotification(data.notifications);
                      }
                      resolve(data);
                  }).error(function (error) {
                      if (error && error.notifications && !_.isEmpty(error.notifications)) {
                          notify.addNotification(error.notifications);
                      } else {
                          notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
                      }
                      reject(error);
                  });
              });
          },
          enviaEmail: function(obj){
              return $http.post(appRoute.linkTo('contato.enviaEmail'), obj);
          }
      }
    }]);
});
